import calendar from './calendar.svg';
import calendar_add from './calendar-add.svg';
import calendar_alarm from './calendar-alarm.svg';
import calendar_check from './calendar-check.svg';
import calendar_clock from './calendar-clock.svg';
import calendar_close from './calendar-close.svg';
import calendar_days from './calendar-days.svg';
import calendar_event from './calendar-event.svg';
import calendar_remove from './calendar-remove.svg';
import calendar_timer from './calendar-timer.svg';
import calendar_timer_add from './calendar-timer-add.svg';
import calendar_timer_close from './calendar-timer-close.svg';
import calendar_timer_remove from './calendar-timer-remove.svg';
import calendar_week from './calendar-week.svg';

export const V2_CALENDAR_ICONS: { [char: string]: string } = {
  calendar,
  calendar_add,
  calendar_alarm,
  calendar_check,
  calendar_clock,
  calendar_close,
  calendar_days,
  calendar_event,
  calendar_remove,
  calendar_timer,
  calendar_timer_add,
  calendar_timer_close,
  calendar_timer_remove,
  calendar_week,
};

export const V2_CALENDAR_ICON_NAMES: string[] = Object.keys(V2_CALENDAR_ICONS);
